import { render, staticRenderFns } from "./BILL_BACK.vue?vue&type=template&id=3b31e8ae"
import script from "./BILL_BACK.vue?vue&type=script&lang=js"
export * from "./BILL_BACK.vue?vue&type=script&lang=js"
import style0 from "./BILL_BACK.vue?vue&type=style&index=0&id=3b31e8ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports